import "../style/reset.css";
import "../style/index.css";
import Vue from "vue";
import router from "./router";
import "element-ui/lib/theme-chalk/index.css";
import elementui from "element-ui";
import App from "../../views/components/app.vue";
import IframeRoute from "./iframeRoute";
import Navigate from "./nav";
import 'babel-polyfill';

Vue.use(elementui, { size: "mini" });

var vueInstance = new Vue({
	el: "#app",
	router: router,
	render: h => h(App)
});

Navigate(window, document, vueInstance, IframeRoute);

window.onmouseup = function(e) {
	if (document.querySelector("#iframeRouteId")) {
		let iframe = document.querySelector("#iframeRouteId").contentWindow;
		if (iframe.document.querySelector(".left .sel-btn-div")) {
			iframe.document.querySelector(".left .sel-btn-div").style.display = "none";
			//iframe.document.querySelector("#forHideSelectBtnUse").focus();
			if (window.parent.TRANSFER_APP.allItemShow) {
				iframe.document.querySelector("#forHideSelectBtnUse").focus();
			}
		}
	}
};